/** Helpers de importes y resumen para ficha SPEC-12. */

import { getBedrockField } from './bedrockNormalize';

export function parseAmount(value) {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const normalized = String(value).trim().replace(/\s/g, '');
  const n = parseFloat(normalized.replace(/\./g, '').replace(',', '.'));
  if (Number.isFinite(n)) return n;
  const plain = parseFloat(normalized);
  return Number.isFinite(plain) ? plain : 0;
}

export function extractVatLines(bedrock) {
  const net = parseAmount(bedrock?.subtotal);
  const total = parseAmount(bedrock?.monto_total);
  const iva21 = parseAmount(getBedrockField(bedrock, 'iva_21'));
  const iva105 = parseAmount(getBedrockField(bedrock, 'iva_10_5'));
  const impuesto = parseAmount(bedrock?.impuesto);
  const lines = [];

  const pushLine = (rate, amount, base = net) => {
    if (amount <= 0) return;
    if (lines.some((l) => Math.abs(l.rate - rate) < 0.001)) return;
    lines.push({ rate, base: base || total - amount, amount });
  };

  pushLine(0.21, iva21, net || total - iva21);
  pushLine(0.105, iva105, net);

  if (!lines.length && impuesto > 0) {
    const ratio = net > 0 ? impuesto / net : 0;
    const rate = ratio > 0 && ratio < 0.15 ? 0.105 : 0.21;
    pushLine(rate, impuesto, net || total - impuesto);
  }

  (bedrock?.tags || []).forEach((tag) => {
    const name = (tag?.nombre || '').toLowerCase();
    const val = parseAmount(tag?.valor);
    if (val <= 0) return;
    if (name.includes('10.5') || name.includes('10,5') || name.includes('105')) {
      pushLine(0.105, val);
    } else if (name.includes('iva') || name.includes('21')) {
      pushLine(0.21, val);
    }
  });

  if (!lines.length && net > 0 && total > net) {
    const perc = (bedrock?.retenciones || []).reduce(
      (sum, r) => sum + parseAmount(r?.importe),
      0
    );
    const diff = total - net - perc;
    if (diff > 0.01) {
      const dist21 = Math.abs(diff / net - 0.21);
      const dist105 = Math.abs(diff / net - 0.105);
      pushLine(dist105 < dist21 ? 0.105 : 0.21, diff);
    }
  }

  return lines.sort((a, b) => b.rate - a.rate);
}

export function resolveAiSummary(bedrock) {
  if (!bedrock || typeof bedrock !== 'object') return '';

  const direct = [bedrock.overview, bedrock.summary, bedrock.description]
    .map((s) => (typeof s === 'string' ? s.trim() : ''))
    .find(Boolean);

  if (direct) return direct;

  const title = (bedrock.title || '').trim();
  const tipo = (bedrock.tipo_documento || '').trim();
  const emisor = (bedrock.razon_social_emisor || '').trim();
  const receptor = (bedrock.razon_social_receptor || '').trim();
  const fecha = (bedrock.fecha_emision || '').trim();
  const total = parseAmount(bedrock.monto_total);
  const moneda = bedrock.moneda || 'ARS';

  const parts = [];
  if (tipo || title) parts.push(tipo || title);
  if (emisor) parts.push(`emitido por ${emisor}`);
  if (receptor) parts.push(`a ${receptor}`);
  if (fecha) parts.push(`con fecha ${fecha}`);
  if (total > 0) {
    parts.push(
      `Total ${moneda} ${total.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`
    );
  }
  if (bedrock.categoria_documento) {
    parts.push(`Categoría: ${bedrock.categoria_documento}`);
  }

  return parts.join('. ').replace(/\.\./g, '.').trim();
}
